<template>
  <v-container class="pa-0">

    <TitleWithSwitch
      :model-value="reinforcementInput.dike_reinforcement_input.is_enabled"
      @update:model-value="onValueChanged({parameter: 'dike_reinforcement_input.is_enabled', value: $event})"
      :class="[
                getDirtyClass(reinforcementInput, 'dike_reinforcement_input.is_enabled'),
                isLocked ? 'disable-events' : '']"
      text="Dike"
    />

    <v-expand-transition>
      <v-row
        dense
        v-if="reinforcementInput.dike_reinforcement_input.is_enabled"
      >
        <v-col sm="12" md="3">
          <v-select
            variant="underlined"
            color="primary"
            :model-value="reinforcementInput.dike_reinforcement_input.selected_slope"
            @update:model-value="
                onValueChanged({parameter: 'dike_reinforcement_input.selected_slope', value: $event}),
                checkForCrestLevelAndSettlement()
              "
            :items="slopeChoices"
            :class="[
                  getDirtyClass(reinforcementInput, 'dike_reinforcement_input.selected_slope'),
                  isLocked ? 'disable-events' : '']"
            label="Slope"
            item-value="value"
            item-title="display_name"
            hide-details
          />
        </v-col>
        <v-col sm="12" md="3">
          <v-select
            variant="underlined"
            color="primary"
            :model-value="reinforcementInput.dike_reinforcement_input.overtopping_rate"
            @update:model-value="
                onValueChanged({parameter: 'dike_reinforcement_input.overtopping_rate', value: $event}),
                checkForCrestLevelAndSettlement()
              "
            label="Over topping rate"
            :class="[
                  getDirtyClass(reinforcementInput, 'dike_reinforcement_input.overtopping_rate'),
                  isLocked ? 'disable-events' : '']"
            :items="overToppingOptions"
            item-value="value"
            :item-title="item => `q = ${item.display_name} l/s/m`"
            hide-details
          />
        </v-col>
        <v-col sm="12" md="3">
          <v-select
            variant="underlined"
            color="primary"
            :model-value="reinforcementInput.dike_reinforcement_input.year"
            @update:model-value="
                onValueChanged({parameter: 'dike_reinforcement_input.year', value: $event}),
                checkForCrestLevelAndSettlement()
              "
            :class="[
                  getDirtyClass(reinforcementInput, 'dike_reinforcement_input.year'),
                  isLocked ? 'disable-events' : '']"
            label="Year"
            :items="yearChoices"
            item-value="id"
            item-title="year"
            hide-details
          />
        </v-col>
        <v-col sm="12" md="3">
          <v-row density="compact">
            <v-col sm="12" md="6">
              <v-text-field
                color="primary"
                variant="underlined"
                :model-value="reinforcementInput.dike_reinforcement_input.crest_level"
                :disabled="fetchingCrestLevelAndSettlement"
                @update:model-value="onValueChanged({parameter: 'dike_reinforcement_input.crest_level', value: $event})"
                :class="[
                      getDirtyClass(reinforcementInput, 'dike_reinforcement_input.crest_level'),
                      isLocked ? 'disable-events' : '']"
                hide-details
                type="number"
              >
                <template v-slot:label>
                  <span style="font-size: 12px">Crest level</span>
                </template>
              </v-text-field>
            </v-col>
            <v-col sm="12" md="6">
              <v-text-field
                color="primary"
                variant="underlined"
                :model-value="reinforcementInput.dike_reinforcement_input.settlement"
                :disabled="fetchingCrestLevelAndSettlement"
                @update:model-value="onValueChanged({parameter: 'dike_reinforcement_input.settlement', value: $event})"
                :class="[
                      getDirtyClass(reinforcementInput, 'dike_reinforcement_input.settlement'),
                      isLocked ? 'disable-events' : '']"
                hide-details
                label="Settlement"
                type="number"
              >
                <template v-slot:label>
                  <span style="font-size: 12px">Settlement</span>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col sm="12" md="3">
          <v-text-field
            color="primary"
            variant="underlined"
            :model-value="reinforcementInput.dike_reinforcement_input.width_crest"
            @update:model-value="onValueChanged({parameter: 'dike_reinforcement_input.width_crest', value: $event})"
            :class="[
                  getDirtyClass(reinforcementInput, 'dike_reinforcement_input.width_crest'),
                  isLocked ? 'disable-events' : '']"
            label="Width crest"
            hide-details
            type="number"
          />
        </v-col>
        <v-col sm="12" md="3">
          <v-text-field
            color="primary"
            variant="underlined"
            :model-value="reinforcementInput.dike_reinforcement_input.outer_slope"
            @update:model-value="onValueChanged({parameter: 'dike_reinforcement_input.outer_slope', value: $event})"
            :class="[
                  getDirtyClass(reinforcementInput, 'dike_reinforcement_input.outer_slope'),
                  isLocked ? 'disable-events' : '']"
            label="Outer Slope"
            hide-details
            type="number"
          />
        </v-col>
        <v-col sm="12" md="3">
          <v-text-field
            color="primary"
            variant="underlined"
            :model-value="reinforcementInput.dike_reinforcement_input.inner_slope"
            @update:model-value="onValueChanged({parameter: 'dike_reinforcement_input.inner_slope', value: $event})"
            :class="[
                  getDirtyClass(reinforcementInput, 'dike_reinforcement_input.inner_slope'),
                  isLocked ? 'disable-events' : '']"
            label="Inner Slope"
            hide-details
            type="number"
          />
        </v-col>
        <v-col sm="12" md="3">
          <v-select
            variant="underlined"
            color="primary"
            :model-value="reinforcementInput.dike_reinforcement_input.continue_outer_slope"
            @update:model-value="onValueChanged({parameter: 'dike_reinforcement_input.continue_outer_slope', value: $event})"
            :class="[
                  getDirtyClass(reinforcementInput, 'dike_reinforcement_input.continue_outer_slope'),
                  isLocked ? 'disable-events' : '']"
            :items="continueOuterSlopeChoices"
            hide-details
          >
            <template v-slot:label>
              <span style="font-size: 12px">Continue outer slope?</span>
            </template>
          </v-select>
        </v-col>
        <v-col sm="12" md="6">
          <v-select
            variant="underlined"
            color="primary"
            :model-value="reinforcementInput.dike_reinforcement_input.starting_point"
            @update:model-value="onValueChanged({parameter: 'dike_reinforcement_input.starting_point', value: $event})"
            :items="startingPointChoices"
            :class="[
                  getDirtyClass(reinforcementInput, 'dike_reinforcement_input.starting_point'),
                  isLocked ? 'disable-events' : '']"
            item-title="display_name"
            item-value="value"
            label="Starting point outer crest inner-/outertoe"
            hide-details
          />
        </v-col>
        <v-col sm="12" md="3">
          <v-text-field
            color="primary"
            variant="underlined"
            v-if="showLocationConnection"
            :model-value="reinforcementInput.dike_reinforcement_input.x_location_connection"
            @update:model-value="onValueChanged({parameter: 'dike_reinforcement_input.x_location_connection', value: $event})"
            :class="[
                  getDirtyClass(reinforcementInput, 'dike_reinforcement_input.x_location_connection'),
                  isLocked ? 'disable-events' : '']"
            label="X location connection"
            hide-details
            type="number"
          />
        </v-col>
        <v-col sm="12" md="3">
          <v-text-field
            color="primary"
            variant="underlined"
            v-if="showLocationConnection"
            :model-value="reinforcementInput.dike_reinforcement_input.z_location_connection"
            @update:model-value="onValueChanged({
                parameter: 'dike_reinforcement_input.z_location_connection',
                value: $event === '' ? null : $event,
              })"
            :class="[
                  getDirtyClass(reinforcementInput, 'dike_reinforcement_input.z_location_connection'),
                  isLocked ? 'disable-events' : '']"
            label="Z location connection"
            hide-details
            type="number"
          />
        </v-col>
      </v-row>
    </v-expand-transition>
  </v-container>
</template>

<script>
  import { mapActions, mapGetters, mapState } from "vuex"
  import DirtyFieldsMixIn from "@/mixins/DirtyFieldsMixIn.vue"
  import TitleWithSwitch from "@/components/reinforcement/TitleWithSwitch.vue"
  import { get as getByPath } from "lodash"
  import ReinforcementFormMixin from "@/mixins/ReinforcementFormMixin.vue"

  export default {
    name: "DikeReinforcementForm",
    components: { TitleWithSwitch },
    mixins: [DirtyFieldsMixIn, ReinforcementFormMixin],
    computed: {
      ...mapState("reinforcementGenerate", {
        overToppingOptions: state => state.overToppingRateOption,
        continueOuterSlopeChoices: state => state.continueOuterSlopeChoices,
        fetchingCrestLevelAndSettlement: state => state.fetchingCrestLevelAndSettlement
      }),
      ...mapState("years", {
        yearChoices: state => state.items
      }),
      ...mapGetters("reinforcementGenerate", {
        slopeChoices: "getSlopeChoices",
        startingPointChoices: "getStartingPointChoices"
      }),
      showLocationConnection () {
        return this.reinforcementInput.dike_reinforcement_input.starting_point !== "current_outer_crest"
      }
    },
    methods: {
      ...mapActions("reinforcementGenerate", {
        setNestedParameter: "setNestedParameter",
        updateGenerateOption: "updateGenerateOption",
        fetchCrestLevelAndSettlement: "fetchCrestLevelAndSettlement",
        toggleFetchingCrestLevelAndSettlement: "toggleFetchingCrestLevelAndSettlement"
      }),
      async updateOption () {
        await this.updateGenerateOption()
        this.dirtyItems = []
      },
      async checkForCrestLevelAndSettlement () {
        const needToUpdateCrestLevelAndSettlement = [
          "dike_reinforcement_input.year",
          "dike_reinforcement_input.selected_slope",
          "dike_reinforcement_input.overtopping_rate"
        ].every(path => getByPath(this.reinforcementInput, path))

        if (needToUpdateCrestLevelAndSettlement) {
          try {
            this.toggleFetchingCrestLevelAndSettlement()
            const { settlement, crest_level } = await this.fetchCrestLevelAndSettlement()
            this.onValueChanged({ parameter: "dike_reinforcement_input.settlement", value: settlement })
            this.onValueChanged({ parameter: "dike_reinforcement_input.crest_level", value: crest_level })
          } catch (e) {
            console.log(e)
          } finally {
            this.toggleFetchingCrestLevelAndSettlement()
          }
        }
      }
    }
  }
</script>

<style scoped>
  .v-input {
    font-size: 14px;
  }

  .text-label {
    height: 100%;
    display: flex;
    align-items: flex-end;
    font-size: 14px;
  }

</style>
